// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__Q2uky","HomeNavigation":"Navigation_HomeNavigation__iqYbQ","RightSide":"Navigation_RightSide__x9Rnp","LeftSide":"Navigation_LeftSide__xOGXH"};